import React from "react";
import SimplePage from "../../shared/SimplePage";

export default function Service() {
  return <SimplePage title="Service" />;
}
